export default function (Component) {
      Component.options.__routemeta = "\n{\n  \"requiresAuth\": true\n}\n"
    }